module.exports = {"650402001":"老城路街道","650402002":"高昌路街道","650402003":"葡萄沟街道","650402100":"七泉湖镇","650402101":"大河沿镇","650402102":"亚尔镇","650402103":"艾丁湖镇","650402104":"葡萄镇","650402203":"恰特喀勒乡","650402204":"二堡乡","650402205":"三堡乡","650402206":"胜金乡","650402400":"红柳河园艺场","650402401":"原种场","650402502":"兵团二二一团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/650402.json
// module id = 2846
// module chunks = 0